/**
 * Phase F — Reserved (Waiting) variant.
 *
 * Pre-fills with current reservation data (decision #2).
 * Comment field shown; required ONLY for Close (PRD #8).
 *
 * Buttons: Assign (green) · Close (red)
 * APIs:    POST /api/tables/{code}/assign · /close
 */
import { useState } from "react";
import DialogFieldGroup, {
  buildInitialValues,
  buildPayload,
} from "@/components/dialog/DialogFieldGroup";
import { useAssignTable, useCloseTable } from "@/hooks/useTableMutations";

export default function ReservedForm({ table, onClose }) {
  const [values, setValues] = useState(buildInitialValues(table));
  const [errors, setErrors] = useState({});
  const assign = useAssignTable();
  const close = useCloseTable();

  const submitting = assign.isPending || close.isPending;

  const handleAssign = () => {
    setErrors({});
    const payload = buildPayload(values, { includeComments: true });
    assign.mutate(
      { code: table.code, payload, version: table.version },
      { onSuccess: onClose },
    );
  };

  const handleClose = () => {
    const comment = (values.comments ?? "").trim();
    if (!comment) {
      setErrors({ comments: "Comment is required to close a reservation." });
      return;
    }
    setErrors({});
    close.mutate(
      { code: table.code, payload: { comments: comment }, version: table.version },
      { onSuccess: onClose },
    );
  };

  return (
    <>
      <DialogFieldGroup
        values={values}
        setValues={setValues}
        showComment
        commentRequired
        errors={errors}
      />

      <div
        className="flex justify-end gap-3 px-5 py-4 border-t"
        style={{ borderColor: "#E5E7EB" }}
      >
        <button
          data-testid="dlg-btn-assign"
          onClick={handleAssign}
          disabled={submitting}
          className="px-5 py-2 rounded-md font-semibold text-sm text-white disabled:opacity-50 transition-opacity"
          style={{ backgroundColor: "#16A34A" }}
        >
          {assign.isPending ? "Assigning…" : "Assign"}
        </button>
        <button
          data-testid="dlg-btn-close"
          onClick={handleClose}
          disabled={submitting}
          className="px-5 py-2 rounded-md font-semibold text-sm text-white disabled:opacity-50 transition-opacity"
          style={{ backgroundColor: "#DC2626" }}
        >
          {close.isPending ? "Closing…" : "Close"}
        </button>
      </div>
    </>
  );
}
